module.exports = __webpack_public_path__ + "img/sec_in4.cd24dc52.jpg";